import { ExternalLink } from '../atoms/ExternalLink';

export type ContactType = 'subscription' | 'student';

type Props = {
  contactType: ContactType;
};

export const ContactLink = ({ contactType }: Props): JSX.Element => {
  switch (contactType) {
    case 'subscription':
      return <ExternalLink href="https://samurai.tayori.com/f/samurai-terakoya">こちらのフォーム</ExternalLink>;
    case 'student':
      return <ExternalLink href="https://lin.ee/8833HzT">こちらのLINE</ExternalLink>;
    default:
      throw new Error(`Unsupported contactType: ${contactType}`);
  }
};
